import { ChangeDetectionStrategy, Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-menu',
  template: `<ng-template #panel>
  <div class="mcrai-menu__panel">
    <ng-content></ng-content>
  </div>
</ng-template>
`,
  styles: [`.mcrai-menu__panel{display:flex;flex-direction:column;border:1px solid}`],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
  host: {
    '[class.mcrai-menu]': 'true'
  }
})
export class MenuComponent implements OnInit {
  @ViewChild(TemplateRef) private _template: TemplateRef<any>;

  get template(): TemplateRef<any> {
    return this._template;
  }

  constructor() { }

  ngOnInit() { }

}
